import { transportOrdersApi as generatedApi } from './generated/transportOrdersApi';

const LIST_ID = 'LIST' as const;

/**
 * Cache wiring for the generated transport order endpoints. It lives here rather than in
 * `generated/transportOrdersApi.ts` so `npm run api:generate` cannot overwrite it. The
 * `TransportOrder` tag type is declared once on `baseApi`.
 */
export const transportOrdersApi = generatedApi.enhanceEndpoints({
    endpoints: {
        listTransportOrders: {
            providesTags: [{ type: 'TransportOrder', id: LIST_ID }],
        },
        listCurrentTransportOrders: {
            providesTags: [{ type: 'TransportOrder', id: LIST_ID }],
        },
        getTransportOrder: {
            providesTags: (_result, _error, arg) => [{ type: 'TransportOrder', id: arg.transportOrderId }],
        },
        getTransportOrderRoute: {
            providesTags: (_result, _error, arg) => [{ type: 'TransportOrder', id: arg.transportOrderId }],
        },
        createTransportOrder: {
            invalidatesTags: [{ type: 'TransportOrder', id: LIST_ID }],
        },
        updateTransportOrder: {
            invalidatesTags: (_result, _error, arg) => [
                { type: 'TransportOrder', id: LIST_ID },
                { type: 'TransportOrder', id: arg.transportOrderId },
            ],
        },
        cancelTransportOrder: {
            invalidatesTags: (_result, _error, arg) => [
                { type: 'TransportOrder', id: LIST_ID },
                { type: 'TransportOrder', id: arg.transportOrderId },
            ],
        },
    },
});

export const {
    useListTransportOrdersQuery,
    useListCurrentTransportOrdersQuery,
    useGetTransportOrderQuery,
    useCreateTransportOrderMutation,
    useUpdateTransportOrderMutation,
    useCancelTransportOrderMutation,
    useGetTransportOrderRouteQuery,
    useListEligibleTransportOrderVehiclesQuery,
} = transportOrdersApi;
